"use client";

import React from "react";
import { ErrorPage } from "components/ErrorPage";
import { sortLinksByLocale } from "utils/sortLinksByLocale";
import { usePathname } from "next/navigation";
import { title, content, links } from "./Custom404Page.content";

export const Custom404Page: React.FC = () => {
  const path = usePathname();
  const locale = path?.startsWith("/us") ? "en-US" : "en-GB";

  return (
    <ErrorPage
      title={title}
      content={content}
      links={sortLinksByLocale(locale, links)}
    />
  );
};
